import React from "react";
import "./style.scss";
import { ClipLoader } from "react-spinners";
import logo from "assets/images/DigiGrainLogo_png.webp";

const ImageLoader = () => {
  return (
<div class="spinner">
  <img src={logo}  />
</div>

  );
};

export default ImageLoader;
